var React = require('react');

function LongArrowAltUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M88.12 468V166.09h80V468a12 12 0 0 1-12 12h-56a12 12 0 0 1-12-12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M25.06 125.09L111.15 39a24 24 0 0 1 33.94 0l86.06 86.09c15.12 15.12 4.41 41-17 41H42.06c-21.38 0-32.06-25.85-17-41z","className":"fa-primary","key":2})]);
}

LongArrowAltUp.defaultProps = {"viewBox":"0 0 256 512","className":"icon"};

module.exports = LongArrowAltUp;

LongArrowAltUp.default = LongArrowAltUp;
